"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SelectContext_1 = require("../../contexts/SelectContext");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Button_1 = __importDefault(require("../Util/Button"));
const Checkbox_1 = __importDefault(require("../Input/Checkbox"));
const inputs_1 = require("../../lib/inputs");
const SelectOption = (props) => {
    const { children, checkedValue = true, uncheckedValue = false } = props;
    const { value, onChange, name } = react_1.useContext(SelectContext_1.SelectContext);
    let isChecked = (Array.isArray(value) ? value.includes(checkedValue) : checkedValue === value);
    if (checkedValue === 'null' && (value === null || value === undefined)) {
        isChecked = true;
    }
    const onClickHandle = react_1.useCallback((e) => {
        const inputEle = inputs_1.getInputElement(e);
        const changeEvent = new Event('change');
        Object.defineProperty(changeEvent, 'target', { writable: false, value: inputEle });
        onChange === null || onChange === void 0 ? void 0 : onChange(changeEvent);
    }, [onChange]);
    return (react_1.default.createElement(Button_1.default, Object.assign({}, props, { onClick: onClickHandle }),
        react_1.default.createElement("span", null, children),
        react_1.default.createElement(Checkbox_1.default, { name: name, checked: isChecked, checkedValue: checkedValue, uncheckedValue: uncheckedValue, readOnly: true })));
};
// not an withInput...
exports.default = withJourney_1.default('j-select-option', SelectOption);
